import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';

import { ScimInstructions } from '../ScimInstructions';

import { ScimInstructionsModalProps } from './ScimInstructionsModal.types';

function ScimInstructionsModal({ isOpen, onClose }: ScimInstructionsModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior="inside">
      <ModalOverlay />
      {/* The shared Modal theme sets dialog maxWidth: 'unset'; an inline style is needed to cap it. */}
      <ModalContent style={{ maxWidth: 'min(720px, 90vw)' }}>
        <ModalHeader>Set up SCIM provisioning</ModalHeader>
        <ModalCloseButton data-testid="scim-instructions-modal-close" />
        <ModalBody>
          <ScimInstructions />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export { ScimInstructionsModal };
